import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_CONFIG, AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment.prod';


declare const Office: any;

var reqHeaders = new Headers();
reqHeaders.append('cache-control', 'max-age=3600');

fetch('/assets/config/env.config.json', { headers: reqHeaders })
  .then(response => response.json())
  .then(config => {
    config.msalInterceptorConfig.protectedResourceMap = new Map(config.msalInterceptorConfig.protectedResourceMap);
    const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
    config.msalConfig.cache.storeAuthStateInCookie = isIE;

    return config;
  })
  .then(config => {
    if (environment.production){
      enableProdMode();
    }

    var bootstrapModule = () => {
      platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }]).bootstrapModule(AppModule)
        .catch(err => console.error(err));
    };

    config.routerConfig = {
      useHash: false
    };

    bootstrapModule();

  })